import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';

import { Cell, List, Row } from '../../../components/List';
import { Loader } from '../../../components/Loader';
import { Modal, ModalControls } from '../../../components/Modal';
import { getPropByName } from '../../../utils/props';
import { addUserToCompany, deleteUserFromCompany } from '../../Companies/actions';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { fetchUser } from '../actions';
import { CompanyQuickCreator } from '../../Companies/pages/QuickCreate/QuickCreate';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';

import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {
  add: false,
  confirmRemove: null,
  loading: false,
};
/* eslint-disable react/prefer-stateless-function */
class UserCompaniesCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  add() {
    this.setState({ loading: true });
    this.props.add(this.state.company.id, result => {
      this.reset();
    });
  }

  remove() {
    this.setState({ loading: true });
    this.props.remove(this.state.confirmRemove.id, result => {
      this.reset();
    });
  }

  render() {
    const user = this.props.user;
    return (
      <Card className="user-info-card info-card data">
        {this.state.loading ? (
          <Loader small />
        ) : (
          <>
            {this.renderAdd()}
            {this.renderConfirmRemove()}
          </>
        )}
        <Container>
          <h2>{this.lbl('user.info.companies.title')}</h2>
          <List>{user.companies?.map(this.renderCompany.bind(this))}</List>
          <Button onClick={this.setStateFn({ add: true })}>+</Button>

          {/* <VehicleCreateFieldCompany
            title={''}
            key={''}
            // type={this.props.type}
            onChange={value => console.log(value, 'Value')}
          /> */}
        </Container>
      </Card>
    );
  }

  renderCompany(company, index) {
    return (
      <Row clickable key={company.id} onClick={this.tofn(`/companies/${company.id}`)}>
        <Cell>{getPropByName(company, 'name', 'x')}</Cell>
        <Cell right>
          <Button onClick={this.setStateFn({ confirmRemove: company })} small>
            x
          </Button>
        </Cell>
      </Row>
    );
  }

  renderConfirmRemove() {
    if (!this.state.confirmRemove) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('remove')}>
        {this.lbl('remove')} ({this.state.confirmRemove.id}) <CompanyLabel company={this.state.confirmRemove} />
        <div className="d-flex justify-content-end gap-2">
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.remove.bind(this)}>
            {this.lbl('remove')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderAdd() {
    if (!this.state.add) return null;
    return (
      <>
        <ModalComponent size={'modal-lg'} onClose={this.reset.bind(this)} title={this.lbl('add')}>
          {this.state.showNewCustomerModal && (
            <CompanyQuickCreator
              userDetails={true}
              resetQuickModal={() => this.setState({ showNewCustomerModal: false })}
              onSelect={result => {
                this.setState({ company: result, showNewCustomerModal: false });
              }}
            />
          )}
          {this.state.selectCompany && (
            <ModalComponent size="xl">
              <CompanySelection
                onSelect={result => {
                  this.setState({
                    company: result,
                    selectCompany: false,
                  });
                }}
              />
            </ModalComponent>
          )}
          {this.state.company ? (
            <HBox vCenter>
              {getPropByName(this.state.company, 'name')}
              <div className="d-flex gap-2">
                <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.add.bind(this)}>
                  {this.lbl('save')}
                </ButtonComponent>
                <ButtonComponent style={'ButtonSoftDelete'} onClick={this.setStateFn({ company: null })}>
                  X
                </ButtonComponent>
              </div>
            </HBox>
          ) : (
            <div>
              <ButtonComponent
                style={'ButtonSoftPrimaryFullWidth'}
                onClick={() => {
                  this.setState({ selectCompany: true });
                }}
              >
                {this.lbl('vehicle.select_customer')}
              </ButtonComponent>
              <div className="mt-2">
                <ButtonComponent
                  style={'ButtonSoftPrimaryFullWidth'}
                  onClick={() => {
                    this.setState({ showNewCustomerModal: true });
                  }}
                >
                  {this.lbl('new_customer')}
                </ButtonComponent>
              </div>
            </div>
          )}

          <div className="d-flex justify-content-end mt-2">
            <ButtonComponent style={'ButtonSoftDelete'} isPrimary onClick={this.reset.bind(this)}>
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </ModalComponent>
      </>
    );
  }
}

UserCompaniesCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    add(company_id, cb) {
      dispatch(addUserToCompany(company_id, ownProps.user.id, cb));
    },
    remove(company_id, cb) {
      dispatch(deleteUserFromCompany(company_id, ownProps.user.id, cb));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserCompaniesCard = compose(withConnect, withRouter)(UserCompaniesCardComp);
